import React, { useContext } from 'react'

import { Link } from '@Components/Link'
import { TrustIconCH } from '@Components/TrustIcons/TrustIconCH'
import { TrustIconDE } from '@Components/TrustIcons/TrustIconDE'
import { TrustIconFR } from '@Components/TrustIcons/TrustIconFR'
import { TrustIconsNL } from '@Components/TrustIcons/TrustIconsNL'
import { MetadataContext } from '@Globals/Metadata'

import styles from './TrustIcon.module.scss'

export type Variant = 'mobile-menu' | 'footer'

interface TrustIconsProps {
  variant: Variant
}

export const TrustIcons = ({ variant }: TrustIconsProps) => {
  const { store, storeURL } = useContext(MetadataContext)

  if (store?.id === '5') {
    return <TrustIconsNL variant={variant} />
  }

  if (store?.id === '7') {
    return <TrustIconDE variant={variant} />
  }

  if (store?.id === '10') {
    return <TrustIconFR variant={variant} />
  }

  if (store?.id === '19' || store?.id === '20') {
    return <TrustIconCH variant={variant} />
  }

  // we only show trendhim Logo for mobile-menu
  if (variant !== 'mobile-menu') {
    return null
  }

  return (
    <div className={styles.normalFooter}>
      <Link
        analytics={{
          dest_page_type: 'frontpages',
          dest_page_type_id: '',
          source_id: 'mobile_menu_footer',
        }}
        href={storeURL('')}
      >
        <img
          alt="Trendhim"
          src="https://eu-images.contentstack.com/v3/assets/blt7dcd2cfbc90d45de/blt59296545a01439bf/trendhim-logo-with-text-v2.svg"
        />
      </Link>
    </div>
  )
}
